import { authedJson } from './client';
import { API_ROUTES } from '../../../shared/api';
import type { DeckSummary, Friend, FriendRequest, PublicProfile, UserMatch } from '../../../shared/types';

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

/** Friends endpoints — all require auth. */
export const friendsApi = {
  list: (g: GetToken, r: DoRefresh) =>
    authedJson<Friend[]>(API_ROUTES.friends, { method: 'GET' }, g, r),
  requests: (g: GetToken, r: DoRefresh) =>
    authedJson<FriendRequest[]>(API_ROUTES.friendRequests, { method: 'GET' }, g, r),
  sendRequest: (body: { userId?: string; email?: string }, g: GetToken, r: DoRefresh) =>
    authedJson<void>(API_ROUTES.friendRequest, { method: 'POST', body: JSON.stringify(body) }, g, r),
  accept: (fromId: string, g: GetToken, r: DoRefresh) =>
    authedJson<void>(API_ROUTES.friendAccept, { method: 'POST', body: JSON.stringify({ fromId }) }, g, r),
  decline: (fromId: string, g: GetToken, r: DoRefresh) =>
    authedJson<void>(API_ROUTES.friendDecline, { method: 'POST', body: JSON.stringify({ fromId }) }, g, r),
  remove: (userId: string, g: GetToken, r: DoRefresh) =>
    authedJson<void>(API_ROUTES.friend(userId), { method: 'DELETE' }, g, r),
  decks: (g: GetToken, r: DoRefresh) =>
    authedJson<DeckSummary[]>(API_ROUTES.friendsDecks, { method: 'GET' }, g, r),
};

/** Public profile endpoints. Passing the token (when present) lets the server
 *  tell whether the viewer is a friend / has a pending request. */
export const usersApi = {
  profile: (userId: string, g: GetToken, r: DoRefresh) =>
    authedJson<PublicProfile>(API_ROUTES.user(userId), { method: 'GET' }, g, r),
  decks: (userId: string, g: GetToken, r: DoRefresh) =>
    authedJson<DeckSummary[]>(API_ROUTES.userDecks(userId), { method: 'GET' }, g, r),
  search: (username: string, g: GetToken, r: DoRefresh) =>
    authedJson<UserMatch[]>(API_ROUTES.usersSearch(username), { method: 'GET' }, g, r),
};
